import { Box, Button, Grid, Typography, MenuItem, TextField, Divider, Modal, Accordion, AccordionSummary, AccordionDetails, FormControlLabel, Checkbox, CircularProgress, LinearProgress, Autocomplete } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HttpRequest } from "../HttpRequest";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { AddCircleOutline, ArrowBackIos, CheckBox, HelpOutline } from "@mui/icons-material";
import CustomInputLabel from "../common/CustomInputLabel";
import { useDispatch, useSelector } from "react-redux";
import { setProductTypeData, setProductCategory, setProductName, setProductDescription, setProductIsPackage, setMaxNoOfItems, setVariations, setFeaturedImage, setAdditionalImages, setPricingData, setTagsData, setAdditionalServicesData, setThumbnailImage } from "../../features/productSlice";
import CloseIcon from "@mui/icons-material/Close";
import PricingComponent from "./PricingComponent";
import imagePlaceholder from "../../images/img-holder-icn.svg";
import { SuccessAlert } from "../common/snackbar/success";
import { ErrorAlert } from "../common/snackbar/error";
import generateImageUrl from "../common/generateImageUrl";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomSelect from "../common/customSelectInput";
import secureLocalStorage from "react-secure-storage";

const AddProductsmodal = {
  borderRadius: "10px",
  backgroundColor: "#fff",
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "600px",
  height: "390px",
  p: 2,
};
const AddServicesmodal = {
  borderRadius: "10px",
  backgroundColor: "#fff",
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "600px",
  height: "auto",
  p: 2,
  overflow: 'scroll'
};
const AddProducts = (props) => {
  const { productTypeData, productName, productCategory, productDescription, productIsPackage, maxNoOfItems, featuredImage, thumbnail, additionalImages, variations, tagsData, additionalServicesData, pricingData } = useSelector((state) => state.product);
  const dispatch = useDispatch();

  const [productTypeOptions, setProductTypeOptions] = useState([
    {
      id: 1,
      label: "Simple Product",
      value: "simple_product",
      description: "Product variations shares same stock and pricing",
    },
    {
      id: 2,
      label: "Variable Product",
      value: "variable_product",
      description: "Each product variations has its own stock and pricing",
    },
  ]);
  const { additionalServicesEnabled, ecommerceUrlEnabled } = useSelector((store) => store.configs);
  const [categories, setCategories] = useState([]);
  const additionalImagesItems = [0, 1, 2, 3];
  const [productType, setProductType] = useState(productTypeData ? productTypeData : '');
  const [tags, setTags] = useState([]);
  const [additionalServices, setAdditionalServices] = useState([]);
  const navigate = useNavigate();
  const [servicesEnabled, setServicesEnabled] = useState(additionalServicesEnabled);
  const [uploading, setUploading] = useState('');
  const [tagDataData, setTagDataData] = useState({
    tagName: "",
    tagDescription: "",
  })
  const [categorySearch, setCategorySearch] = useState('');


  const handleproductTypeOptionsChange = (value) => {
    setProductType(value);
    setFormData((prevFormData) => ({ ...prevFormData, productType: value }));
    dispatch(setProductTypeData(value));
  };

  const [openVariantAdd, setOpenVariantAdd] = useState(false);
  const [openTagsAdd, setOpenTagsAdd] = useState(false);
  const [openServicesAdd, setOpenServicesAdd] = useState(false);

  const handleOPenVariantAdd = () => {
    setOpenVariantAdd(true);
  };
  const handleCloseVariantAdd = () => {
    setOpenVariantAdd(false);
  };
  const handleOPenTagsAdd = () => {
    setOpenTagsAdd(true);
  };
  const handleCloseTagsAdd = () => {
    setOpenTagsAdd(false);
  };
  const handleOPenServicesAdd = () => {
    setOpenServicesAdd(true);
  };
  const handleCloseServicesAdd = () => {
    setOpenServicesAdd(false);
  };

  const [displayBars, setDisplayBars] = useState("productDetails");

  const activeClassBar = {
    height: "45px",
    backgroundColor: "#fafafa",
    width: "100%",
    color: "#0000",
    cursor: "pointer",
  };
  const inactiveClassBar = {
    height: "45px",
    backgroundColor: "#fff",
    width: "100%",
    color: "#707070",
    cursor: "pointer",
  };

  const activeClassText = {
    color: "#000",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "600",
    paddingTop: "10px",
  };
  const inactiveClassText = {
    color: "#707070",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "600",
    paddingTop: "10px",
  };

  const handleChangeBars = (value) => {
    setDisplayBars(value);
  };
  const [successShow, setSuccessShow] = useState({ state: false, message: "" })
  const [errorShow, setErrorShow] = useState({ state: false, message: "" })

  const [variationName, setVariationName] = useState("");
  const [variationValues, setVariationValues] = useState(" ");
  const [variationNameError, setVariationNameError] = useState(false);
  const [variationNameHelperText, setVariationHelperText] = useState('');
  const [limit, setLimit] = useState(1000);

  const [variationData, setVariationData] = useState(variations);
  const [productFeaturedImage, setProductFeaturedImage] = useState(featuredImage);
  const [additionalProductImages, setAdditionalProductImages] = useState(additionalImages);
  const [selectedTags, setSelectedTags] = useState(tagsData);
  const [selectedAdditionalServices, setSelectedAdditionalServices] = useState(Array.isArray(additionalServicesData) ? additionalServicesData : []);
  const [serviceBoxes, setServiceBoxes] = useState([{ serviceName: '', cost: '' }]);
  const [serviceData, setServiceData] = useState({
    serviceName: '',
    selectionType: '',
    items: []
  });
  const selectOptions = [
    { id: 1, label: 'Multiple', value: 'multiple' },
    { id: 2, label: 'Single', value: 'single' },
  ]

  const handleAddBox = () => {
    setServiceBoxes([...serviceBoxes, { serviceName: '', cost: '', customizable: false }]);
  };
  const handleDeleteBox = (indexToRemove) => {
    setServiceBoxes(serviceBoxes.filter((_, index) => index !== indexToRemove));
  };

  const handleServicesFormData = (e) => {
    setServiceData({ ...serviceData, [e.target.name]: e.target.value });
  }

  const handleChange = (event) => {
    const { name, checked, value } = event.target;
    if (checked) {
      const newTag = { tagId: value, tagName: name };
      const newSelectedTags = [...selectedTags, newTag];
      setSelectedTags(newSelectedTags);
      setFormData((prevFormData) => ({ ...prevFormData, tags: newSelectedTags }));
      dispatch(setTagsData(newSelectedTags));
    } else {
      const newSelectedTags = selectedTags.filter((tag) => tag.tagId !== value);
      setSelectedTags(newSelectedTags);
      setFormData((prevFormData) => ({ ...prevFormData, tags: newSelectedTags }));
      dispatch(setTagsData(newSelectedTags));
    }
  };
  const handleChangeAdditionalServices = (event) => {
    const { name, checked, value } = event.target;
    if (checked) {
      const newService = { serviceId: value, serviceName: name };
      const newSelectedServices = [...selectedAdditionalServices, newService];
      setSelectedAdditionalServices(newSelectedServices);
      setFormData((prevFormData) => ({ ...prevFormData, additionalServices: newSelectedServices }));
      dispatch(setAdditionalServicesData(newSelectedServices));
    } else {
      const newSelectedServices = selectedAdditionalServices?.filter((service) => service.serviceId !== value);
      setSelectedAdditionalServices(newSelectedServices);
      setFormData((prevFormData) => ({ ...prevFormData, additionalServices: newSelectedServices }));
      dispatch(setAdditionalServicesData(newSelectedServices));
    }
  };
  const handleServiceSubmit = () => {
    const isAnyEmpty = serviceBoxes.some(box => box.serviceName === '' || box.cost === '');
    if (isAnyEmpty) {
      setErrorShow({ state: true, message: "Please fill all fields" });
      return;
    }
    if (serviceData.serviceName === '' || serviceData.selectionType === '') {
      setErrorShow({ state: true, message: "Please fill all fields" });
      return;
    }

    const items = serviceBoxes.map(box => ({ itemName: box.serviceName, itemPrice: box.cost, isCustomizable: box?.customizable }));
    const data = { ...serviceData, items };

    HttpRequest({
      method: 'POST',
      url: `/api/v1/ecommerce/add_additional_services`,
      body: data,

    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Additional Service added successfully" });
        handleCloseServicesAdd();
        setServiceData({
          serviceName: '',
          selectionType: '',
          items: []
        });
        setServiceBoxes([{ serviceName: '', cost: '' }]);
        fetchAdditionalServices();
      } else {
        setErrorShow({ state: true, message: data.response?.data?.message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: "Error adding service" });
    })

  }
  const handleChangeVariationName = (e) => {
    const { value } = e.target;
    if (value.trim() !== '' && value.includes(' ')) {
      setErrorShow({ state: true, message: 'Variant name cannot contain spaces!' });
      setVariationHelperText('Variant name cannot contain spaces!');
      setVariationNameError(true);
    } else {
      setVariationName(value);
    }
  }
  const handleVariations = () => {
    const checkVariationName = variationData.findIndex(
      (item) => item && item.variationName === variationName
    );
    if (checkVariationName === -1) {
      const newVariationData = [
        ...variationData,
        {
          variationName: variationName.trim(),
          variationValues: variationValues.split(","),
        },
      ];
      setVariationData(newVariationData);
      setFormData({ ...formData, variations: newVariationData });
      dispatch(setVariations(newVariationData));
      secureLocalStorage.setItem("variationData", JSON.stringify(newVariationData));
    } else {
      const updatedVariationData = variationData.map((item) => {
        if (item.variationName === variationName) {
          return { ...item, variationValues: variationValues.split(",") };
        }
        return item;
      });
      setVariationData(updatedVariationData);
      setFormData({ ...formData, variations: updatedVariationData });
      dispatch(setVariations(updatedVariationData));
      secureLocalStorage.setItem(
        "variationData",
        JSON.stringify(updatedVariationData)
      );
    }
    setVariationName("");
    setVariationValues("");
    handleCloseVariantAdd();
  };

  const receivingPricingData = (data) => {
    setFormData({ ...formData, pricing: data });
  };

  const [formData, setFormData] = useState({
    productType: productType,
    productName: productName ? productName : " ",
    productCategory: productCategory ? productCategory : " ",
    isPackage: productIsPackage ? productIsPackage : false,
    noOfItemsInPackage: maxNoOfItems ? maxNoOfItems : 0,
    productDescription: productDescription ? productDescription : " ",
    featuredImage: featuredImage ? featuredImage : " ",
    thumbnail: thumbnail ? thumbnail : ' ',
    additionalImages: additionalImages ? additionalImages : [],
    variations: variations ? variations : [],
    productCategoryId: "",
    pricing: pricingData ? pricingData : [],
    tags: tagsData ? tagsData : [],
    additionalServices: additionalServicesData ? additionalServicesData : []
  });

  const handleFormData = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === 'productCategory') {
      const filteredCategory = categories.find(item => item.categoryName === e.target.value);
      setFormData({ ...formData, productCategoryId: filteredCategory?._id, productCategory: e.target.value })
    }
  };
  const handleTagsFormData = (e) => {
    const { name, value } = e.target
    setTagDataData({ ...tagDataData, [name]: value })
  }
  const findCategoryByName = (categories, categoryName) => {
    for (const category of categories) {
      if (category.categoryName === categoryName) {
        return category;
      }

      if (category.subCategories && category.subCategories.length > 0) {
        const foundInChildren = findCategoryByName(category.subCategories, categoryName);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }

    return null;
  };



  const [pricingObj, setpricingObj] = useState({
    pricing: {
      initialStock: "",
      runningLowLevel: "",
      normalPrice: "",
      discountedPrice: "",
      buyingPrice: ""
    }
  })

  const handlePrincingNewObject = () => {
    let newPricing = pricingObj.pricing
    newPricing = { ...newPricing, variationKey: "default" }

    formData.pricing = [{ ...newPricing }]

    setFormData({ ...formData, pricing: [newPricing] })
    let newPricingData = [newPricing]
    dispatch(setPricingData(newPricingData))
  }
  const handleVariationChange = () => {
    const defaultvariations = [{

      "variationName": "default",
      "variationValues": [
        "default"
      ]

    }]
    setFormData({ ...formData, variations: defaultvariations })
  }

  useEffect(() => {
    handlePrincingNewObject()
    if (productType === "simple_product") {
      handleVariationChange()
    }
  }, [pricingObj])

  const [buttonState, setButtonState] = useState(false);

  const nextButtonState = () => {
    if (displayBars === "productDetails") {
      if (
        formData.productName !== "" &&
        formData.productCategory !== "" &&
        formData.productDescription !== ""
      ) {
        setButtonState(false);
      } else {
        setButtonState(true);
      }
    } else if (displayBars === "productImage") {
      if (
        formData.featuredImage !== ""
      ) {
        setButtonState(false);
      } else {
        setButtonState(true);
      }
    } else if (displayBars === "productVariations") {
      if (formData.variations.length === 0) {
        setButtonState(true);
      } else {
        setButtonState(false);
      }
    } else if (displayBars === "productPricing") {
      if (productType === "simple_product") {
        if (
          formData.pricing.initialStock !== "" &&
          formData.pricing.runningLowLevel !== "" &&
          formData.pricing.normalPrice !== "" &&
          formData.pricing.discountedPrice !== ""
        ) {
          setButtonState(false);
        } else {
          setButtonState(true);
        }
      } else if (productType === "variable_product") {
        if (formData.pricing.length > 0) {
          setButtonState(false);
        } else {
          setButtonState(true);
        }
      }
    }
  };
  const renderMenuItems = (items, level = 1) => {
    const menuItems = [];
    items.forEach((item) => {
      menuItems.push(
        <MenuItem disabled={item.subCategories.length > 0 ? true : false} key={item._id} value={item.categoryName} style={{ paddingLeft: level * 20, width: '98px', height: '20px', margin: '14px 21px 15px 22px', fontFamily: 'Poppins', fontSize: '16px', textAlign: 'left', color: '#707070', fontWeight: level < 2 ? 550 : 'normal', "&:hover": { backgroundColor: '#fff' } }}>
          {item.categoryName}
        </MenuItem>
      );
      if (item.subCategories && item.subCategories.length > 0) {
        const subMenuItems = renderMenuItems(item.subCategories, level + 1);
        menuItems.push(...subMenuItems);
      }
    });
    return menuItems;
  };
  const handleTagAddSubmit = () => {
    if (!tagDataData.tagName) {
      setErrorShow({ state: true, message: "Tag name is required" });
      return;
    }
    if (!tagDataData.tagDescription) {
      setErrorShow({ state: true, message: "Tag description is required" });
      return;
    }
    HttpRequest({
      method: 'POST',
      url: `/api/v1/ecommerce/business/addTag`,
      body: tagDataData

    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Tag Name added successfully" });
        fetchBusinessTags();
        handleCloseTagsAdd();
        setTagDataData({
          tagName: "",
          tagDescription: "",

        })
      } else {
        setErrorShow({ state: true, message: data.response?.data?.message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: "Error adding shipping Region" });
    })
  }
  const handleSubmit = async () => {
    HttpRequest({
      method: "POST",
      url: `/api/v1/ecommerce/create_product`,
      body: formData,
    }).then((data) => {
      if (data.status === 200) {
        setSuccessShow({ state: true, message: "Product created successfully!" });
        dispatch(setProductTypeData(''));
        dispatch(setProductCategory(''));
        dispatch(setProductName(''));
        dispatch(setProductIsPackage(false));
        dispatch(setMaxNoOfItems(0));
        dispatch(setVariations([]));
        dispatch(setTagsData([]));
        dispatch(setProductDescription())
        dispatch(setAdditionalServicesData([]));
        dispatch(setFeaturedImage(''));
        dispatch(setAdditionalImages([]));
        setTimeout(() => {
          navigate('/zed_ecommerce/products')
        }, 3000);
      } else {
        const message = data.response.message;
        setErrorShow({ state: true, message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: 'Failed to create product!' })
    });
  };
  const fetchBusinessVariations = () => {
    const businessNumber = secureLocalStorage.getItem("businessId");
    HttpRequest({
      method: "GET",
      url: `/api/v1/ecommerce/get_business_variations?businessNumber=${businessNumber}`
    }).then((data) => {
      if (data.status === 200) {
        const businessVariationData = data.response.data;
        let newVariationData = [];

        businessVariationData.forEach((variation) => {
          newVariationData.push({
            variationName: variation.variationName.trim(),
            variationValues: variation.variationValues,
          });
        });

        setVariationData(businessVariationData);
        setVariationData(businessVariationData);
        setFormData({ ...formData, variations: businessVariationData });
        dispatch(setVariations(businessVariationData));
      }
    }).catch((error) => {
    });
  };
  const fetchBusinessTags = () => {
    const businessNumber = secureLocalStorage.getItem("businessId");
    HttpRequest({
      method: "GET",
      url: `/api/v1/ecommerce/business/getTag?businessNumber=${businessNumber}`
    }).then((data) => {
      if (data.status === 200) {
        setTags(data.response.data);
      }
    }).catch((error) => {
    });
  };
  const fetchAdditionalServices = () => {
    HttpRequest({
      method: "GET",
      url: `/api/v1/ecommerce/get_additional_services`,
    }).then((data) => {
      if (data.status === 200) {
        setAdditionalServices(data.response.data);
      }
    }).catch((error) => {
   
    });
  };
  useEffect(() => {
    nextButtonState();
  }, [formData, displayBars]);

  const handleNext = () => {
    if (displayBars === "productDetails") {
      setDisplayBars("productImage");
      dispatch(setProductTypeData(formData?.productType));
      dispatch(setProductName(formData.productName));
      dispatch(setProductCategory(formData.productCategory));
      dispatch(setProductDescription(formData.productDescription));
      dispatch(setProductIsPackage(formData?.isPackage));
      dispatch(setMaxNoOfItems(formData?.noOfItemsInPackage));
    } else if (displayBars === "productImage") {
      if (productType === 'simple_product') {
        setDisplayBars("productPricing");
      } else {
        setDisplayBars("productVariations");
      }
    } else if (displayBars === "productImage") {
      setDisplayBars("productVariations");
    } else if (displayBars === "productVariations") {
      setDisplayBars("productPricing");
    } else if (displayBars === "productPricing") {
      setDisplayBars("tags")
    } else if (displayBars === "tags") {
      if (servicesEnabled) {
        setDisplayBars("additionalServices")
      } else {
        handleSubmit();
      }
    } else if (displayBars === "additionalServices") {
      handleSubmit();
    }
  };

  const removeVariation = (variationName, variationValue) => {
    const updatedVariationData = variationData
      .map((item) => {
        if (item.variationName === variationName) {
          const newValue = item.variationValues.filter(
            (value) => value !== variationValue
          );
          return {
            ...item,
            variationValues: newValue.length > 0 ? newValue : null,
          };
        }
        return item;
      })
      .filter((item) => item && item.variationValues !== null);

    setVariationData(updatedVariationData);
    setFormData({ ...formData, variations: updatedVariationData });
    dispatch(setVariations(updatedVariationData));
    secureLocalStorage.setItem("variationData", JSON.stringify(updatedVariationData));
  };
  const removeAllVariationValues = (variationName) => {
    const updatedVariationData = variationData
      .map((item) => {
        if (item.variationName === variationName) {
          return null;
        }
        return item;
      })
      .filter((item) => item !== null);

    setVariationData(updatedVariationData);
    setFormData({ ...formData, variations: updatedVariationData });
    dispatch(setVariations(updatedVariationData));
    secureLocalStorage.setItem("variationData", JSON.stringify(updatedVariationData));
  };

  const handleFeaturedImage = async (event) => {
    setUploading('5');
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      try {
        const file = URL.createObjectURL(selectedFile);
        setProductFeaturedImage(file);
        const { imageUrl, thumbnailUrl } = await generateImageUrl(selectedFile);

        dispatch(setFeaturedImage(imageUrl));
        dispatch(setThumbnailImage(thumbnailUrl));
        setFormData({ ...formData, featuredImage: imageUrl, thumbnail: thumbnailUrl });

        setUploading(null);
      } catch (error) {
        setUploading(null);
      }
    } else {
      setUploading(null);
    }
  };


  const handleAdditionalImages = async (event, index) => {
    setUploading(index);
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      try {
        const fileUrl = URL.createObjectURL(selectedFile);

        const { imageUrl, thumbnailUrl } = await generateImageUrl(selectedFile);

        const updatedImages = [...additionalProductImages];
        updatedImages[index] = { id: index, image: imageUrl };

        setAdditionalProductImages(updatedImages);
        setFormData(prevFormData => ({
          ...prevFormData,
          additionalImages: updatedImages,
        }));

        setUploading(null);
      } catch (error) {
        setUploading(null);
      }
    } else {
      setUploading(null);
    }
  };

  useEffect(() => {
    dispatch(setAdditionalImages(additionalProductImages));
  }, [additionalProductImages, dispatch]);

  const getCategories = () => {
    const businessNumber = secureLocalStorage.getItem("businessId");
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/get_categories?businessNumber=${businessNumber}&categoryName=${categorySearch}&limit=${limit}`
    }).then((data) => {
      let rawCategories = data.response.data;
      const options = [];

      const addCategoryWithLevel = (category, level = 0) => {
        options.push({
          label: category.categoryName,
          value: category.categoryName,
          level,
          id: category?._id,
          disabled: category.subCategories.length > 0
        });
        category.subCategories.forEach(subCategory => {
          addCategoryWithLevel(subCategory, level + 1);
        });
      };

      rawCategories.forEach(category => addCategoryWithLevel(category));

      setCategories(prevCategories => data.response.data.length > 0 ? options : [...prevCategories, ...options]);
      setLimit(data?.response?.count);
    }).catch((error) => {
    });
  }

  useEffect(() => {
    getCategories();
    fetchBusinessVariations();
    fetchBusinessTags();
    fetchAdditionalServices();
  }, [])
  useEffect(() => {
    getCategories();
  }, [categorySearch])

  return (
    <div>
      <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
      <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />
      <div style={{ marginTop: "4%" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
          <Box sx={{ flexDirection: "column" }}>
            <Box>
              <Typography variant="h4" sx={{ color: "#032541", fontSize: "28px", fontStyle: "normal", fontWeight: "600", }}>
                {" "}
                <ArrowBackIos className="" onClick={() => navigate(-1)} /> Add Products
              </Typography>
            </Box>
            <Box>
              <Typography variant="h4" sx={{ color: "#707070", fontSize: "14px", fontStyle: "normal", fontWeight: "normal", }}   >
                Upload activating images and descriptions to make your product   stand out.
              </Typography>
            </Box>
          </Box>
          <Box style={{ marginRight: "15px" }}>
            <Button variant="contained" sx={{ backgroundColor: "#f5f6f7", color: "#6e7074", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", width: "125px", height: "40px", fontWeight: "600", opacity: "0.99", "&:hover": { backgroundColor: "#f5f6f7", color: "#6e7074" } }} onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </Box>
        </Box>
        <Box sx={{ display: "flex" }}></Box>
        <Grid item width={"70%"} style={{ margin: "15px 0px 0px 0px" }}>
          <Typography sx={{ margin: '20px 709px 15px 2px', fontFamily: 'Poppins', fontSize: '16px', textAlign: 'left', color: '#000', fontWeight: 600 }}>What type of product are you adding?</Typography>
          <TextField style={{ width: "50%" }} value={productType} id="outlined-select-meals" select label="Product Type" helperText="" name="paymentType" onChange={(event) => handleproductTypeOptionsChange(event.target.value)}>
            {productTypeOptions?.map((prod, index) => (
              <div key={prod.id} value={prod.value} style={{ padding: "10px 10px 10.5px" }} onClick={() => handleproductTypeOptionsChange(prod.value)}>
                <div onClick={() => handleproductTypeOptionsChange(prod.value)}>
                  <Typography variant="body1" style={{ color: "#000", fontSize: "17px", fontWeight: "600" }} onClick={() => handleproductTypeOptionsChange(prod.value)}>
                    {prod.label}
                  </Typography>
                </div>
                <div style={{ color: "#707070", paddingBottom: "10px" }} onClick={() => handleproductTypeOptionsChange(prod.value)}>
                  {prod.description}
                </div>
                <Divider />
              </div>
            ))}
          </TextField>
        </Grid>
        {productType && <Box>
          <Typography variant="h4" sx={{ color: "#000", fontSize: "18px", fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>
            {productType === "simple_product" ? "Simple Product Details" : "Variable Product Details"}
          </Typography>
        </Box>
        }
        {productType && <Box sx={{ display: "flex", justifyContent: "center", maxWidth: displayBars === "productImage" ? "980px" : "800px", marginTop: "20px" }}>
          <Box style={{ width: "30%", borderTop: "1px solid #e0e0e0", height: "100%" }}>
            <Box style={displayBars === "productDetails" ? activeClassBar : inactiveClassBar} onClick={() => handleChangeBars("productDetails")}>
              <Typography variant="h4" sx={displayBars === "productDetails" ? activeClassText : inactiveClassText}>
                Product Details
              </Typography>
            </Box>
            <Divider />
            <Box style={displayBars === "productImage" ? activeClassBar : inactiveClassBar} sx={{ paddingTop: "10px" }} onClick={() => handleChangeBars("productImage")}>
              <Typography variant="h4" sx={displayBars === "productImage" ? activeClassText : inactiveClassText}>
                Images
              </Typography>
            </Box>
            <Divider />
            <Box style={displayBars === "productVariations" ? activeClassBar : inactiveClassBar} sx={{ paddingTop: "10px", display: productType === 'simple_product' ? 'none' : '' }} onClick={() => handleChangeBars("productVariations")}>
              <Typography variant="h4" sx={displayBars === "productVariations" ? activeClassText : inactiveClassText}>
                Variations
              </Typography>
            </Box>
            <Divider />
            <Box style={displayBars === "productPricing" ? activeClassBar : inactiveClassBar} sx={{ paddingTop: "10px" }} onClick={() => handleChangeBars("productPricing")}>
              <Typography variant="h4" sx={displayBars === "productPricing" ? activeClassText : inactiveClassText}>
                Pricing & Stock
              </Typography>
            </Box>
            <Divider />
            <Box style={displayBars === "tags" ? activeClassBar : inactiveClassBar} sx={{ paddingTop: "10px" }} onClick={() => handleChangeBars("tags")}>
              <Typography variant="h4" sx={displayBars === "tags" ? activeClassText : inactiveClassText}>
                Tags
              </Typography>
            </Box>
            <Divider />
            {servicesEnabled === true && <Box style={displayBars === "additionalServices" ? activeClassBar : inactiveClassBar} sx={{ paddingTop: "10px" }} onClick={() => handleChangeBars("additionalServices")}>
              <Typography variant="h4" sx={displayBars === "additionalServices" ? activeClassText : inactiveClassText}>
                Additional Services
              </Typography>
            </Box>}
            <Divider />
          </Box>
          <Box style={{ width: "70%", borderTop: "1px solid #e0e0e0", borderRight: "1px solid #e0e0e0", height: "100%", borderBottom: "1px solid #e0e0e0", borderLeft: "1px solid #e0e0e0", paddingBottom: "40px" }}>
            {displayBars === "productDetails" ? (
              <Box sx={{ padding: "0px 20px" }}>
                <Typography variant="h4" sx={{ color: "#000", fontSize: "16px", fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>
                  Product Details
                </Typography>
                <Box sx={{ marginTop: "25px" }}>
                  <TextField label="Product Name" value={formData?.productName} name="productName" onChange={handleFormData} style={{ width: "100%" }} />
                </Box>
                <Box sx={{ marginTop: "25px" }}>
                  <Autocomplete
                    style={{ width: "100%" }}
                    id="outlined-select-meals"
                    options={categories}
                    getOptionDisabled={(option) => option.disabled}
                    getOptionLabel={(option) => option.label}
                    value={formData?.productCategory ? { label: formData.productCategory } : null}
                    onInputChange={(event, newInputValue) => {
                      setCategorySearch(newInputValue);
                    }}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          productCategory: newValue.label,
                          productCategoryId: newValue?.id
                        }));
                      } else {
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          productCategory: '',
                          productCategoryId: ''
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Product Category"
                        helperText=""
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        {...props}
                        sx={{ ml: option.level * 2 }}
                      >
                        {option.label}
                      </Box>
                    )}
                  />

                </Box>
                <Box sx={{ marginTop: "25px" }}>
                  <TextField label="Product Description" value={formData?.productDescription} name="productDescription" onChange={handleFormData} style={{ width: "100%" }} multiline minRows={3} />
                </Box>
                <Box sx={{ marginTop: "25px", display: 'flex' }}>
                  <Checkbox style={{ color: "#b4bcc4", margin: '10px 6px 37px 0px', }} checked={formData?.isPackage} value={formData?.isPackage} onChange={(e) => {
                    setFormData({ ...formData, isPackage: !formData?.isPackage });
                  }} />
                  <Typography sx={{ margin: '20px 6px 37px 12px', fontSize: '16px', color: '#707070', fontFamily: 'Poppins' }}>Is a Package</Typography>
                </Box>
                {formData?.isPackage && <Box >
                  <TextField type="number" label="No. of Items per Package" value={formData?.noOfItemsInPackage} name="noOfItemsInPackage" onChange={handleFormData} style={{ width: "100%" }} />
                </Box>}
              </Box>
            ) : displayBars === "productImage" ? (
              <Box sx={{ padding: "0px 20px", minHeight: "250px" }}>
                <Box sx={{ display: "flex", marginTop: "20px" }}>
                  <Typography sx={{ width: "114px", height: "20px", margin: "0 226px 10px 0", fontFamily: "Poppins", fontSize: "14px", fontWeight: 600, color: "#000", textAlign: "left", lineHeight: "normal", fontStyle: "normal", letterSpacing: "normal", fontStretch: "normal" }}>
                    Featured Image
                  </Typography>
                  <Typography sx={{ width: "152px", height: "20px", margin: "0 81px 10px 22px", fontFamily: "Poppins", fontSize: "14px", fontWeight: 600, color: "#000", textAlign: "left", lineHeight: "normal", fontStyle: "normal", letterSpacing: "normal", fontStretch: "normal" }}>
                    Upload Other Images
                  </Typography>
                </Box>
                <Grid container>
                  <Grid item lg={6} sx={{ textAlign: 'center', alignContent: 'center' }}>
                    <label htmlFor="featured-image">
                      <input style={{ display: "none" }} id="featured-image" name="featured-image" type="file" onChange={handleFeaturedImage} accept=".png, .jpeg, .jpg" />
                      <Box sx={{ width: "320px", height: "320px", borderRadius: "12px", border: "solid 1px #e0e0e0", backgroundColor: "#fff", alignItems: 'center' }}>
                        <Box sx={{ width: "300px", height: "300px", borderRadius: "5px", backgroundColor: "#f5f5f5", margin: "10px", textAlign: "center", alignContent: "center" }}>
                          {productFeaturedImage ? <>
                            <img src={productFeaturedImage} alt="" style={{ width: "100%", height: "100%", maxHeight: '250px', maxWidth: '250px', objectFit: "contain", alignItems: "center", textAlign: "center" }} />
                          </> :
                            <>
                              <img src={imagePlaceholder} alt="" style={{ width: "60.6px", height: "60.6px", objectFit: "contain", alignItems: "center", textAlign: "center" }} />
                              <Typography sx={{ fontFamily: "Poppins", fontSize: "14px", color: "#000", fontWeight: 500 }}>
                                Click to upload or drag and drop
                              </Typography>
                              <Typography sx={{ fontFamily: "Poppins", fontSize: "12px", color: "#707070", fontWeight: "normal" }}>
                                PNG, JPG or JPEG
                              </Typography>
                              <Typography sx={{ fontFamily: "Poppins", fontSize: "12px", color: "#707070", fontWeight: "normal" }}>
                                Recommended size (1000px x 1000px)
                              </Typography>
                            </>
                          }
                          {uploading === '5' &&
                            <Box>
                              <LinearProgress sx={{ marginTop: '0%' }} /> <Typography>Uploading File... </Typography>
                            </Box>
                          }
                        </Box>
                      </Box>
                    </label>
                  </Grid>
                  <Grid item lg={6}>
                    <Typography sx={{ width: "225px", height: "35px", margin: "10px 10px 25px 20px", fontFamily: "Poppins", fontSize: "14px", fontWeight: "normal", fontStretch: "normal", color: "#707070", textAlign: "left", letterSpacing: "normal", lineHeight: "normal" }}>
                      Recommended size (1000px x 1000px) PNG, JPG or JEPG
                    </Typography>
                    <Grid container spacing={2}>
                      {additionalImagesItems.map((item, index) => (
                        <Grid key={index} item sx={{ display: "flex" }} lg={6}>
                          <label htmlFor={`other-images-${index}`}>
                            <input style={{ display: "none" }} id={`other-images-${index}`} name={`other-images-${index}`} type="file" onChange={(event) => handleAdditionalImages(event, index)} accept=".png, .jpeg, .jpg" />
                            <Box sx={{ width: "110px", height: "auto", margin: "5px 28px 10px 20px", padding: "11px", borderRadius: "8px", border: "solid 1px #e0e0e0", backgroundColor: "#fff" }}>
                              <Box sx={{ width: "70px", height: "70px", padding: "7.3px 20px 40px 20px", borderRadius: "5px", backgroundColor: "#f5f5f5", alignContent: "center", textAlign: "center" }}>
                                <img src={additionalProductImages.length > 0 && additionalProductImages[index] ? additionalProductImages[index].image : imagePlaceholder} alt="" style={{ width: additionalProductImages.length > 0 && additionalProductImages[index] ? '100%' : '100%', height: additionalProductImages.length > 0 && additionalProductImages[index] ? '100%' : '48.2px', objectFit: "contain", margin: "15px 15px 0px 0" }} />
                                {uploading === index &&
                                  <Box>
                                    <LinearProgress sx={{ marginTop: '0%' }} /> <Typography>Uploading... </Typography>
                                  </Box>
                                }
                              </Box>
                            </Box>
                          </label>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            ) : displayBars === "productVariations" ? (
              <Box sx={{ padding: "0px 20px", minHeight: "250px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="h4" sx={{ color: "#000", fontSize: "16px", fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>
                    Product Variations
                  </Typography>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }} onClick={handleOPenVariantAdd}>
                    <Typography variant="h4" sx={{ color: "#032541", fontSize: "14px", fontStyle: "normal", fontWeight: "600" }}>
                      <AddCircleOutlineIcon />
                    </Typography>
                    <Typography variant="h4" sx={{ color: "#032541", fontSize: "14px", fontStyle: "normal", fontWeight: "600", marginTop: "5px" }}>
                      Add Variations
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ marginTop: "25px" }}>
                  <Typography variant="h6" sx={{ color: "#707070", fontSize: "14px", fontStyle: "normal", fontWeight: "600" }}>
                    Create different variations such as size, color, etc.
                  </Typography>
                  {variations.length > 0 && (
                    <Box sx={{ marginTop: "25px", display: "flex" }}>
                      <Box>
                        {variations.map((item, index) => (
                          <div key={index}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                              <span style={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography variant="h6" sx={{ color: "#707070", fontSize: "14px", fontStyle: "normal", fontWeight: "600", paddingTop: "10px" }}>
                                  Name:
                                </Typography>
                                <Typography variant="h6" sx={{ color: "#032541", fontSize: "14px", fontStyle: "normal", fontWeight: "700", paddingTop: "10px", display: 'flex' }}>
                                  {item?.variationName}{" "}  <CloseIcon sx={{ fontSize: "20px", color: "#FF0000", cursor: "pointer" }} onClick={() => removeAllVariationValues(item?.variationName)} />
                                </Typography>
                              </span>
                            </Box>
                            <Box sx={{ display: "flex", marginTop: "20px", flexWrap: 'wrap' }}>
                              <Typography variant="h6" sx={{ color: "#707070", fontSize: "14px", fontStyle: "normal", fontWeight: "600", paddingTop: "10px" }}>
                                Values:
                              </Typography>
                              {item?.variationValues?.map((value, index) => (
                                <Box key={index} sx={{ minwidth: "57px", height: "34px", backgroundColor: "#efefef", borderRadius: "5px", padding: "5px 10px 5px 10px", margin: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                  <Typography variant="h6" sx={{ color: "#707070", fontSize: "16px", fontStyle: "normal", fontWeight: "600" }}>
                                    <CloseIcon sx={{ fontSize: "14px", color: "#707070", cursor: "pointer" }} onClick={() => removeVariation(item?.variationName, value)} />
                                    {value}
                                  </Typography>
                                </Box>
                              ))}
                            </Box>
                          </div>
                        ))}

                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            ) : displayBars === "productPricing" ? (
              <Box sx={{ padding: "0px 20px", minHeight: "250px" }}>
                <Typography variant="h4" sx={{ color: "#000", fontSize: "16px", fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>
                  Pricing & Stock
                </Typography>
                <Typography variant="h6" sx={{ color: "#707070", fontSize: "14px", fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>
                  {productType === "simple_product" ? "Set the pricing and stock of the product" : "Set the price and stock for each product variation."}
                </Typography>
                {productType === "simple_product" ? (
                  <>
                    <Box sx={{ marginTop: "25px", display: "flex", justifyContent: "space-between" }}>
                      <TextField label="Initial Stock" value={pricingObj?.pricing?.initialStock} name="initialStock" onChange={(e) => setpricingObj({ ...pricingObj, pricing: { ...pricingObj.pricing, initialStock: e.target.value } })} style={{ width: "100%", marginRight: "10px" }} />
                      <TextField label="Running Low Level" value={pricingObj?.pricing?.runningLowLevel} name="runningLowLevel" onChange={(e) => setpricingObj({ ...pricingObj, pricing: { ...pricingObj.pricing, runningLowLevel: e.target.value } })} style={{ width: "100%" }} />
                    </Box>
                    <Box sx={{ marginTop: "25px", display: "flex", justifyContent: "space-between" }}>
                      <TextField label="Normal Price" value={pricingObj?.pricing?.normalPrice} name="normalPrice" onChange={(e) => setpricingObj({ ...pricingObj, pricing: { ...pricingObj.pricing, normalPrice: e.target.value } })} style={{ width: "100%", marginRight: "10px" }} />
                      <TextField label="Discounted  Price" value={pricingObj?.pricing?.discountedPrice} name="discountedPrice" onChange={(e) => setpricingObj({ ...pricingObj, pricing: { ...pricingObj.pricing, discountedPrice: e.target.value } })} style={{ width: "100%" }} />
                    </Box >
                    <Box sx={{ marginTop: "20px" }}>
                      <TextField label="Buy Price" value={pricingObj?.pricing?.buyingPrice} name="buyingPrice" onChange={(e) => setpricingObj({ ...pricingObj, pricing: { ...pricingObj.pricing, buyingPrice: e.target.value } })} style={{ width: '100%', marginRight: "10px" }} />
                    </Box>
                  </>
                ) : productType === "variable_product" ? (
                  variationData.length === 0 ? (
                    <Box sx={{ marginTop: "25px" }}>
                      <Typography variant="h6" sx={{ color: "#707070", fontSize: "14px", fontStyle: "normal", fontWeight: "600" }}>
                        Please add variations to set pricing and stock
                      </Typography>

                    </Box>
                  ) : (
                    <PricingComponent variationData={variationData} receivingPricingData={receivingPricingData} />
                  )
                ) : null}
              </Box>
            ) : displayBars === "tags" ? (
              <Box sx={{ padding: "16px 14.5px 7px 17px", minHeight: "250px", margin: '19px 25px 25px 25px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Box sx={{ flexDirection: 'column' }}>
                    <Typography sx={{ margin: '0 200px 10px 0', fontFamily: 'Poppins', fontSize: '16px', fontWeight: 600, color: '#000', textAlign: 'left' }}>Tags</Typography>
                    <Typography sx={{ margin: '10px 82px 10px 0', fontFamily: 'Poppins', fontSize: '14px', textAlign: 'left', color: '#707070', textWrap: 'nowrap' }}>Select tags to this product</Typography>
                  </Box>
                  <Box sx={{ display: 'flex' }} onClick={handleOPenTagsAdd}>
                    <AddCircleOutline sx={{ width: '18.6px', height: '18.6px', color: '#032541' }} />
                    <Typography sx={{ margin: '0 0 0 6px', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 600, color: '#032541', textWrap: 'nowrap' }}>Add Tags</Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                  {
                    tags?.map((tag) => (
                      <FormControlLabel key={tag._id} control={<Checkbox checked={selectedTags.some(selectedTag => selectedTag.tagId === tag._id)} value={tag._id} onChange={handleChange} inputProps={{ 'aria-label': 'controlled', backgroundColor: '#032541' }} />} name={tag.tagName} label={tag.tagName} />
                    )
                    )}
                </Box>
              </Box>
            ) : displayBars === "additionalServices" ? (
              <Box sx={{ padding: "16px 14.5px 7px 17px", minHeight: "250px", margin: '19px 25px 25px 25px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Box sx={{ flexDirection: 'column' }}>
                    <Typography sx={{ margin: '0 20px 10px 0', fontFamily: 'Poppins', fontSize: '16px', fontWeight: 600, color: '#000', textAlign: 'left', textWrap: 'nowrap' }}>Additional Services</Typography>
                    <Typography sx={{ margin: '10px 82px 10px 0', fontFamily: 'Poppins', fontSize: '14px', textAlign: 'left', color: '#707070', textWrap: 'nowrap' }}>Select additional services to this product</Typography>
                  </Box>
                  <Box sx={{ display: 'flex' }} onClick={handleOPenServicesAdd}>
                    <AddCircleOutline sx={{ width: '18.6px', height: '18.6px', color: '#032541' }} />
                    <Typography sx={{ margin: '0 0 0 6px', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 600, color: '#032541', textWrap: 'nowrap' }}>Add Services</Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                  {
                    additionalServices?.map((service) => (
                      <Box sx={{}}>
                        <Accordion sx={{ boxShadow: 'none', width: '100%' }}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ width: '100%' }} />} aria-controls="panel1-content" id="panel1-header">
                            <FormControlLabel key={service._id} control={<Checkbox checked={selectedAdditionalServices?.some(selectedService => selectedService.serviceId === service._id)} value={service._id} onChange={handleChangeAdditionalServices} inputProps={{ 'aria-label': 'controlled', backgroundColor: '#032541', flexDirection: 'column' }} />} name={service.serviceName} label={service.serviceName} />
                          </AccordionSummary>
                          {service?.items?.map((serviceItem) => (
                            <AccordionDetails sx={{ display: 'flex', width: '100%' }}>
                              <Typography>{serviceItem?.itemName}</Typography>
                              <Typography>+ {serviceItem?.itemPrice}</Typography>
                            </AccordionDetails>
                          ))}
                        </Accordion>
                      </Box>
                    )
                    )}
                </Box>
              </Box>
            ) : (
              <Box sx={{ padding: "0px 20px", minHeight: "250px" }}>
                Product Details
              </Box>
            )}
          </Box>
        </Box>
        }
        {productType && <Box style={{ width: "800px", height: "390px", display: "flex", justifyContent: "flex-end" }}>
          <Button disabled={buttonState} variant="contained" sx={{ backgroundColor: !buttonState ? "#032541" : "#707070", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", width: "125px", height: "40px", marginTop: "20px", "&:hover": { backgroundColor: !buttonState ? "#032541" : "#707070" } }} onClick={handleNext}>
            Next
          </Button>
        </Box>
        }
      </div>
      {/* Modals */}
      <Modal open={openVariantAdd} onClose={handleCloseVariantAdd} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" border="none">
        <Box sx={AddProductsmodal}>
          <Box sx={{ padding: "10px" }}>
            <Box>
              <Typography variant="h4" sx={{ color: "#032541", fontSize: "20px", fontStyle: "normal", fontWeight: "600" }}>
                Add Variations
              </Typography>
            </Box>
            <Box sx={{ marginTop: "20px" }}>
              <CustomInputLabel label={"Variation Name"} name={"variationName"} required={true} />
              <Typography variant="h5" sx={{ color: "#707070", fontSize: "12px", fontStyle: "normal", fontWeight: "600" }}>
                Name is the attribute of the variation e.g Size
              </Typography>
              <TextField helperText={variationNameHelperText} error={variationNameError} label="Variation Name" value={variationName} name="variationName" onChange={handleChangeVariationName} style={{ width: "100%" }} />
            </Box>
            <Box sx={{ marginTop: "20px" }}>
              <CustomInputLabel label={"variationValues"} name={"variationValues"} required={true} />
              <Typography variant="h5" sx={{ color: "#707070", fontSize: "12px", fontStyle: "normal", fontWeight: "600" }}>
                Values are different attributes in the variation e.g Medium
              </Typography>
              <TextField label="variation Values" value={variationValues} name="variationValues" onChange={(e) => setVariationValues(e.target.value)} style={{ width: "100%" }} />
              <Box sx={{ marginTop: "5px", display: "flex", justifyContent: "flex-end" }}>
                <Typography variant="h5" sx={{ color: "#707070", fontSize: "12px", fontStyle: "normal", fontWeight: "600" }}>
                  Separate multiple values with a comma “,” e.g Medium, Large
                </Typography>
              </Box>
            </Box>
            <Box sx={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
              <Button variant="contained" sx={{ backgroundColor: "#f5f6f7", color: "#6e7074", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", width: "125px", height: "40px", marginRight: "10px", "&:hover": { backgroundColor: "#f5f6f7" } }} onClick={handleCloseVariantAdd}>
                Cancel
              </Button>
              <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", width: "125px", height: "40px", "&:hover": { backgroundColor: "#032541" } }} onClick={handleVariations}>
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={openTagsAdd} onClose={handleCloseTagsAdd} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" border="none">
        <Box sx={AddProductsmodal}>
          <Box sx={{ padding: "10px" }}>
            <Box>
              <Typography variant="h4" sx={{ color: "#032541", fontSize: "20px", fontStyle: "normal", fontWeight: "600" }}>
                Add Tags
              </Typography>
            </Box>
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <CustomInputLabel label="Tag  Name" placeholder="Enter Tag Name " />
              <TextField label="Tag Name" value={tagDataData?.tagName} name="tagName" onChange={handleTagsFormData} InputProps={{ sx: { width: "490px", height: '50px', fontSize: "0.875rem", "& fieldset": { borderColor: "#bec5d1", }, }, }} />
            </Box>
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <CustomInputLabel label="Tag Description" placeholder="Enter Tag  Description*" />
              <TextField name={"tagDescription"} value={tagDataData.tagDescription} onChange={handleTagsFormData} placeholder={"Description"} variant="outlined" margin="dense" sx={{ marginBottom: 2 }} multiline minRows={2} InputProps={{ sx: { width: "490px", height: '70px', fontSize: "0.875rem", "& fieldset": { borderColor: "#bec5d1", }, }, }} />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignContent: "end", mr: '80px' }}>
              <Button variant="contained" sx={{ backgroundColor: "#fff", color: "#dc3545", textTransform: "none", borderRadius: "5px", marginRight: "10px", border: "1px solid #dc3545", padding: "10.4px 30px 9.6px 30px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#fff", color: "#dc3545" } }} onClick={handleCloseTagsAdd}>
                Cancel
              </Button>
              <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" } }} onClick={handleTagAddSubmit}>
                Add Tag
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={openServicesAdd} onClose={handleCloseServicesAdd} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" border="none">
        <Box sx={AddServicesmodal}>
          <Box sx={{ padding: "10px" }}>
            <Box>
              <Typography variant="h4" sx={{ color: "#032541", fontSize: "20px", fontStyle: "normal", fontWeight: "600" }}>
                Add Additional Services
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left' }}>
              <Box sx={{ width: "50%" }}>
                <CustomInputLabel label="ServiceName Name" placeholder="Enter ServiceName Name" />
                <TextField label="Service Name" value={serviceData?.serviceName} name="serviceName" onChange={handleServicesFormData} style={{ width: "100%" }} placeholder="Enter Service Name" />
              </Box>
              <Box sx={{ width: "50%", marginLeft: "10px", marginTop: "-6px" }}>
                <CustomInputLabel label="Select Type" placeholder="Enter Select Type" />
                <CustomSelect value={serviceData?.selectionType} name="selectionType" options={selectOptions} onChange={handleServicesFormData} placeholder={"Select Type"} sm={"sm"} />
              </Box>
            </Box>
            <Typography variant="h4" sx={{ color: "#032541", fontSize: "20px", fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>Service Items</Typography>
            {serviceBoxes.map((box, index) => (
              <Box>
                <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left', marginBottom: '10px' }}>
                  <Box sx={{ width: "50%" }}>
                    <CustomInputLabel label="Service Name" placeholder="Enter Service Name" />
                    <TextField label="Service" value={box.serviceName} name={`serviceName-${index}`} onChange={(e) => {
                      const updatedBoxes = [...serviceBoxes];
                      updatedBoxes[index].serviceName = e.target.value;
                      setServiceBoxes(updatedBoxes);
                    }} style={{ width: "100%" }} placeholder="Service Name" />
                  </Box>
                  <Box sx={{ width: "50%", marginLeft: "10px", marginTop: "" }}>
                    <CustomInputLabel label="Cost" placeholder="Enter Cost" />
                    <TextField type="number" label="Service cost" value={box.cost} name={`cost-${index}`} onChange={(e) => {
                      const updatedBoxes = [...serviceBoxes];
                      updatedBoxes[index].cost = e.target.value;
                      setServiceBoxes(updatedBoxes);
                    }} style={{ width: "100%" }} />
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: "end", marginTop: "20px", marginLeft: "20px" }}>
                    <Typography variant="h4" sx={{ color: "#dc3545", fontSize: "30px", fontStyle: "normal", fontWeight: "600", marginTop: "20px", cursor: 'pointer' }} onClick={() => handleDeleteBox(index)}>
                      <DeleteIcon sx={{ fontSize: "30px" }} />
                    </Typography>
                  </Box>
                </Box>
                <Box style={{ display: "flex", }}>
                  <Checkbox style={{ color: "#b4bcc4", margin: '10px 6px 37px 0px', }} checked={box?.customizable} value={box?.customizable} onChange={(e) => {
                    const updatedBoxes = [...serviceBoxes];
                    updatedBoxes[index].customizable = !box?.customizable;
                    setServiceBoxes(updatedBoxes);
                  }} />
                  <Typography sx={{ margin: '20px 6px 37px 12px', fontSize: '16px', color: '#707070', fontFamily: 'Poppins' }}>Customizable</Typography>
                  <HelpOutline sx={{ color: "#b4bcc4", margin: '20px 6px 37px 12px', }} />
                </Box>
              </Box>
            ))}

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: "end" }}>

              <Typography variant="h4" sx={{ color: "#032541", fontSize: "14px", fontStyle: "normal", fontWeight: "600", marginTop: "20px", cursor: 'pointer' }} onClick={handleAddBox}>
                <AddCircleOutlineIcon sx={{ fontSize: "14px" }} />   Add Another
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: "end" }}>

              <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", marginTop: "20px", display: "flex", justifyContent: "flex-end" }} onClick={handleServiceSubmit}>
                Add  Service
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default AddProducts;
